module.exports = __webpack_public_path__ + "img/228ab98e90e5c16bb3700cb3a13062a.fa737c68.jpg";